module.exports = __webpack_public_path__ + "static/media/bulle_discovery_FR_1.a1410fc0.png";